// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";

function ProjectItemLoading(props) {
  return JsxRuntime.jsx("div", {
              className: "project-item-loading"
            });
}

var make = ProjectItemLoading;

export {
  make ,
}
/* react/jsx-runtime Not a pure module */
